import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityService {

  constructor(private http: HttpClient) { }

  getEntities(entityType: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/projects/entities/${entityType}`;
    return this.http.get(url);
  }
}
